import { useLocale } from "@reco/shared/src/composables/useLocale";
import { createI18n } from "vue-i18n";

import cs_CZ from "./cs_CZ.json";
import de_DE from "./de_DE.json";
import en_GB from "./en_GB.json";
import es_ES from "./es_ES.json";
import fr_BE from "./fr_BE.json";
import fr_FR from "./fr_FR.json";
import nl_BE from "./nl_BE.json";
import nl_NL from "./nl_NL.json";
import pl_PL from "./pl_PL.json";
import sk_SK from "./sk_SK.json";

const messages = {
  cs_CZ,
  de_DE,
  en_GB,
  es_ES,
  nl_NL,
  pl_PL,
  sk_SK,
  fr_BE,
  fr_FR,
  nl_BE,
};

const { locale } = useLocale();

const i18n = createI18n({
  locale: locale.value,
  fallbackLocale: "en_GB",
  messages,
});

export default i18n;
